import { useParams } from "react-router-dom";
import {
  useCreateShareLinkMutation,
  useDeleteConversationMutation,
  useGetConversationHistoryInfiniteQuery,
  useGetQuestionsBySessionIdInfiniteQuery,
  useLazyGetShareLinkQuery,
  usePinConversationMutation,
  useRenameConversationMutation,
  useRevokeShareLinkMutation,
} from "@/services/(my-space)/api.ai-assistant";
import {
  ConversationsHistory as SharedConversationsHistory,
  type ConversationHistoryApi,
} from "@/components/ai-assistant/conversation-history";
import { DYNAMIC_SESSION_ID_KEY } from "@/routes/my-space/routes.ai-assistant";

const api: ConversationHistoryApi = {
  useConversations: useGetConversationHistoryInfiniteQuery,
  useQuestionsBySession: useGetQuestionsBySessionIdInfiniteQuery,
  usePinConversation: usePinConversationMutation,
  useRenameConversation: useRenameConversationMutation,
  useDeleteConversation: useDeleteConversationMutation,
  useLazyGetShareLink: useLazyGetShareLinkQuery,
  useCreateShareLink: useCreateShareLinkMutation,
  useRevokeShareLink: useRevokeShareLinkMutation,
};

export const ConversationsHistory = () => {
  const { [DYNAMIC_SESSION_ID_KEY]: activeSessionId } = useParams();
  return (
    <SharedConversationsHistory api={api} activeSessionId={activeSessionId} />
  );
};
